(function($, window){
  $.fn.ProxyLink = function(options) {
    return this.each(function(){
      var settings = $.extend({
        excludes: []
      }, options );

      $(this).on('click', function(e) {
          console.log(settings.onBeforeUnload);
        if (settings.onBeforeUnload && typeof settings.onBeforeUnload === 'function' ){
            settings.onBeforeUnload($(this));
        }

        var link = $(this).attr('data-link-proxy');
        for (var i = 0; i < settings.excludes.length; i++) {
          // Check if element is excluded first
          var excludedClass = settings.excludes[i].replace('.', '');

          if ($(e.target).hasClass(excludedClass) || $(e.target).closest(settings.excludes[i]).length) {
            e.stopPropagation();
            return;
          }
        }
        e.preventDefault();
        window.location.href = link;
      }.bind(this));
    });
  }
})(jQuery, window);


$(function() {
  // Activate proxylinks
  $('[data-link-proxy]').ProxyLink({
    excludes: ['.slick-dots', '.product-tile__variants', '.swym-add-to-wishlist-view-product', '.product-tile__hover--color__dot', '.product-tile__hover__option']
  });

});
